export const colors = {
  primary: "#10585b",
  secondary: "#f89116",
  terciary: "#ffae12",
};
